var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.51606H19.25V3.03928C19.25 1.66467 18.1375 0.5625 16.75 0.5625H9.25C7.8625 0.5625 6.75 1.66467 6.75 3.03928V5.51606H3C1.6125 5.51606 0.5 6.61823 0.5 7.99284V21.6151C0.5 22.9897 1.6125 24.0919 3 24.0919H23C24.3875 24.0919 25.5 22.9897 25.5 21.6151V7.99284C25.5 6.61823 24.3875 5.51606 23 5.51606ZM9.25 3.03928H16.75V5.51606H9.25V3.03928ZM23 21.6151H3V19.1384H23V21.6151ZM23 15.4232H3V7.99284H6.75V10.4696H9.25V7.99284H16.75V10.4696H19.25V7.99284H23V15.4232Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobsIcon.3365ad4efed7c005a1c94827fcfd7cf2.svg";
export { ForwardRef as ReactComponent };